import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Header3 from "../../components/header/Header3";
import Footer2 from "../../components/footer2";
import Gotop from "../../components/gotop";
import { Link, NavLink } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; // Import icons

import Breadcrumb from "../../components/breadcrumb";
import { useContext } from "react";
import { AuthContext } from "../../AuthContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

DashboardUser.propTypes = {};

function DashboardUser(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
   const [categoriesnew2, setCategoriesnew2] = useState([]);
   const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
     fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"); // Adjust the URL if needed
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"); // Adjust the URL if needed
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"); // Adjust the URL if needed
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

   const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"); // Adjust the URL if needed
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const { logout } = useContext(AuthContext);

// === User Appointments (Dashboard – Read Only) ===
const [appointments, setAppointments] = useState([]);
const [loadingAppointments, setLoadingAppointments] = useState(false);
  
  const [initialFormData, setInitialFormData] = useState({});
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    contactNo: "",
    gender: "",
    Dateofbirth: "",
    Timeofbirth: "",
    Placeofbirth: ""
  });
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const storedUserId = localStorage.getItem("userId"); 
        if (!storedUserId) return;
    
        const response = await axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getuserbyid/${storedUserId}`);
        if (response.data) {
          const userData = {
            fullName: response.data.Named || "",
            email: response.data.Email || "",
            contactNo: response.data.Cno || "",
            gender: response.data.Gender || "",
            Dateofbirth: response.data.Dateofbirth || "",
            Timeofbirth: response.data.Timeofbirth || "",
            Placeofbirth: response.data.Placeofbirth || "",
          };
          setFormData(userData);
          setInitialFormData(userData); // Store original data
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
  
    fetchUserData();
  }, []);  // Runs only on component mount
    const [errors, setErrors] = useState({});
  
    const validateForm = () => {
      let newErrors = {};
      if (!formData.fullName.trim()) newErrors.fullName = "Full Name is required.";
      if (!formData.gender.trim()) newErrors.gender = "Gender is required.";

 if (!formData.Dateofbirth.trim()) newErrors.Dateofbirth = "Date of birth is required.";
  // if (!formData.Timeofbirth.trim()) newErrors.Timeofbirth = "Time of birth is required.";
  //  if (!formData.Placeofbirth.trim()) newErrors.Placeofbirth = "Place of birth is required.";

      if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
        newErrors.email = "Valid Email is required.";
      if (!/^[6-9]\d{9}$/.test(formData.contactNo))
        newErrors.contactNo = "Enter a valid 10-digit Indian mobile number.";
 
    
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };
  
    const handleChange = (e) => {
      const { name, value } = e.target;
    
      if (name === "contactNo") {
        if (!/^\d*$/.test(value)) return; 
      }
    
      setFormData({ ...formData, [name]: value });
    };

    
    const handleBlur = (event) => {
      const { name, value } = event.target;
      let newErrors = { ...errors };
    
      if (!value) {
        newErrors[name] = `${name.charAt(0).toUpperCase() + name.slice(1)} is required`;
      } else {
        delete newErrors[name]; // Remove error if the field is valid
      }
    
      setErrors(newErrors);
    };
    const [userId, setUserId] = useState(null);

    useEffect(() => {
      const storedUserId = localStorage.getItem("userId");
      if (storedUserId) {
        setUserId(storedUserId);
      }
    }, []);
const [isSubmitting, setIsSubmitting] = useState(false);
   const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validateForm()) return;

  setIsSubmitting(true); // Disable the button

  const updatedData = { ...formData, userId };

  try {
    const response = await axios.post(
      "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/updateuserprofile",
      updatedData,
      { headers: { "Content-Type": "application/json" } }
    );

    toast.success(response.data.message);
   setTimeout(() => {
      window.location.href = "/userdashboard";
    }, 5000);
  } catch (error) {
    console.error("Error updating profile:", error);
    toast.error(error.response?.data?.message || "An error occurred");
  } finally {
    setIsSubmitting(false); // Optional: re-enable in case of errors
  }
};
    const hasChanges = JSON.stringify(formData) !== JSON.stringify(initialFormData);
    const headers = ["ID", "Dummy Data Title", "Status", "Remarks", "Actions"];
  const placeholderRows = Array(5).fill(["#", "Coming Soon", "Pending", "Dummy Table Records.", "-" ]);




  const [userStatus, setUserStatus] = useState({ Vstatus: "1", Email: "" });
const [showModal, setShowModal] = useState(false);

useEffect(() => {
  const fetchUserStatus = async () => {
    try {
      const response = await axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getuserbyidnew/${userId}`);
      if (response.data) {
        setUserStatus({
          Vstatus: response.data.Vstatus,
          Email: response.data.Email || "",
        });
      }
    } catch (error) {
      console.error("Error fetching user status:", error);
    }
  };
  fetchUserStatus();
}, [userId]);

useEffect(() => {
  const fetchUserAppointments = async () => {
    if (!userId) return;

    setLoadingAppointments(true);
    try {
      const res = await axios.get(
        "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/appointments"
      );

      const allAppointments = Array.isArray(res.data) ? res.data : [];

      // 🔐 Filter only logged-in customer's appointments
      const userAppointments = allAppointments.filter(
        (a) => String(a.Customerid) === String(userId)
      );

      setAppointments(userAppointments);
    } catch (err) {
      console.error("Error fetching user appointments:", err);
      setAppointments([]);
    } finally {
      setLoadingAppointments(false);
    }
  };

  fetchUserAppointments();
}, [userId]);

const formatDateDMY = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

const formatDate = (value) => {
  if (!value) return "-";

  // MySQL DATETIME: YYYY-MM-DD HH:MM:SS
  // Also supports: YYYY-MM-DDTHH:MM:SS
  if (typeof value === "string") {
    const match = value.match(
      /^(\d{4})-(\d{2})-(\d{2})/
    );

    if (match) {
      const [, year, month, day] = match;
      return `${day}-${month}-${year}`;
    }
  }

  // Handles JavaScript Date objects returned by mysql2
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const day = String(value.getDate()).padStart(2, "0");
    const month = String(value.getMonth() + 1).padStart(2, "0");
    const year = value.getFullYear();

    return `${day}-${month}-${year}`;
  }

  return "-";
};

const formatTime = (value) => {
  if (!value) return "-";

  // MySQL DATETIME: YYYY-MM-DD HH:MM:SS
  // Also supports: YYYY-MM-DDTHH:MM:SS
  if (typeof value === "string") {
    const match = value.match(
      /[ T](\d{2}):(\d{2})/
    );

    if (match) {
      const [, hour, minute] = match;
      return `${hour}:${minute}`;
    }
  }

  // Handles JavaScript Date objects returned by mysql2
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const hour = String(value.getHours()).padStart(2, "0");
    const minute = String(value.getMinutes()).padStart(2, "0");

    return `${hour}:${minute}`;
  }

  return "-";
};

const handleVerifyClick = () => {
  if (userStatus.Email === "") {
    setShowModal(true);
  } else {
    window.location.href = "/verifyuseremail"; // same behavior as NavLink
  }
};

const remainingDays = (purchaseDate, validity) => {
  const start = new Date(purchaseDate);
  const end = new Date(start);
  end.setDate(start.getDate() + Number(validity));

  const diff = Math.ceil((end - new Date()) / (1000 * 60 * 60 * 24));
  return diff;
};

const [courseLedger, setCourseLedger] = useState([]);

useEffect(() => {
  if (!userId) return;

  axios
    .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/api/user/course-ledger/${userId}`)
    .then(res => setCourseLedger(res.data))
    .catch(err => console.error(err));
}, [userId]);

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  background: "#ffffff"
};

const thStyle = {
  padding: "14px 18px",
  fontSize: 12,
  fontWeight: 700,
  color: "#0f172a",
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  backgroundColor: "#f8fafc",
  borderBottom: "2px solid #e5e7eb",
  textAlign: "left",
  verticalAlign: "middle",
  whiteSpace: "nowrap"
};

const tdStyle = {
  padding: "14px 16px",
  fontSize: 13,
  color: "#374151",
  borderBottom: "1px solid #e5e7eb",
  verticalAlign: "top",
  lineHeight: "22px"
};

  
  return (
    <>
    <Helmet>
            <title>Your Dashboard - Adhigyanam | Sauntesthyam LLP</title>
          </Helmet>
          <div className="menu-mobile-popup">
        <div className="modal-menu__backdrop" onClick={handleMobile}></div>
        <div className="widget-filter">
          <div className="mobile-header">
            <div id="logo" className="logo">
              <Link to="/home">
                <img className="site-logo" src={logo} alt="Image" />
              </Link>
            </div>
            <Link className="title-button-group" onClick={handleMobile}>
              <i className="icon-close"></i>
            </Link>
          </div>

       <Tabs className="tf-tab">
            

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item ">
                        <Link
                          to="/home"
                          className="iteam-menu"
                          
                        >
                          Home
                        </Link>
                      </li>
                      {/* <li className="menu-item ">
                        <Link
                          to="/about"
                          className="iteam-menu"
                          
                        >
                          About Us
                        </Link>
                      </li> */}

                   

                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("services");
                          }}
                        >
                          eConsultation
                        </Link>
                        <Collapse isOpened={toggle.key === "services"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "services" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew1.length > 0 ? (
          categoriesnew1.map((categorynew1, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                     
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("courses");
                          }}
                        >
                          eLearning
                        </Link>
                        <Collapse isOpened={toggle.key === "courses"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "courses" ? "block" : "none"
                              }`,
                            }}
                          >
                           {categoriesnew2.length > 0 ? (
          categoriesnew2.map((categoriesnew2, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}
                            
                          </ul>
                        </Collapse>
                      </li>
                    <li className="menu-item ">
                        <Link
                          to="/epooja"
                          className="iteam-menu"
                          
                        >
                          ePooja
                        </Link>
                      </li>
                     
                         <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("horoscope");
                          }}
                        >
                         Horoscope
                        </Link>
                        <Collapse isOpened={toggle.key === "horoscope"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "horoscope" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew.length > 0 ? (
          categoriesnew.map((categorynew, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                       <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("blog");
                          }}
                        >
                          Blog
                        </Link>
                        <Collapse isOpened={toggle.key === "blog"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "blog" ? "block" : "none"
                              }`,
                            }}
                          >

 {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                      <li className="menu-item ">
                        <Link
                          to="/support"
                          className="iteam-menu"
                          
                        >
                         FAQ & Support
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>

           
            </div>
          </Tabs>
          <div className="header-customize-item button" style={{padding: "0px 0px",
    background:"none",
    backgroundColor:"#14a077",
    borderRadius: "4px",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "21px",
    color: "white",
    borderColor: "transparent",
    textTransform: "capitalize"}}>
            <Link to="/userdashboard" style={{color: "#ffffff"}}>Dashboard</Link>
          </div>
           
          

           <div className="mobile-footer">
            <div className="icon-infor d-flex aln-center">
              <div className="icon">
                <span className="icon-call-calling">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                </span>
              </div>
              <div className="content">
                <p>Need help? 24/7</p>
                <h6>
                   <Link to={`tel:918960708425`}>+91-8960708425</Link>
                </h6>
              </div>
            </div>
            <p><b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</p>
            <p style={{marginTop:"15px"}}><b>Write To Us On</b>: <Link to={`mailto:sauntesthyam@gmail.com`} style={{textDecoration:"underline"}}>sauntesthyam@gmail.com</Link>, <Link to={`mailto:info@adhigyanam.com`}  style={{textDecoration:"underline"}}>info@adhigyanam.com</Link></p>
            <div className="wd-social d-flex aln-center" style={{marginTop:"15px"}}>
      <ul className="list-social d-flex aln-center">
                                     <li><Link to="https://www.facebook.com/Adhigyanam"><i className="icon-facebook"></i></Link></li>
                                     <li><Link to="https://www.instagram.com/the_vedic_astro"><i className="icon-instagram1"></i></Link></li>
                                     <li><Link to="https://x.com/adhigyanam"><i className="icon-twitter"></i></Link></li>
                                 </ul>
    </div>
          </div>
          <div >
                      <button onClick={logout} className="header-customize-item button" style={{padding: "12px 20px",
    background:"none",
    backgroundColor:"white",
    borderRadius: "4px",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "21px",
    color: "black",
    borderColor: "red",
    textTransform: "capitalize"}}>Logout</button>
                    </div>
        </div>
      </div>
 

      
      <Header3 clname="act1" handleMobile={handleMobile} />
        <Breadcrumb title="Dashboard" />
        <section className="account-section" style={{    padding: "30px 0px 0px"}}>
     <div className="tf-container">


  {/* ===== TABS START ===== */}
 <Tabs selectedIndex={tabIndex} onSelect={(i) => setTabIndex(i)}>
  <TabList
  style={{
    display: "flex",
    justifyContent: "center",
    gap: 24,
    marginBottom: 12,
    borderBottom: "1px solid #e5e7eb",
    flexWrap: "wrap",
  }}
>
  {[
    "Get Started",
    "Manage Your Profile",
    "Enrolled Courses",
    "Your Appointments"
  ].map((label, index) => (
    <Tab
      key={label}
      style={{
        padding: "12px 30px",
        fontSize: 14,
        fontWeight: 700,
        cursor: "pointer",
        color: tabIndex === index ? "#0f766e" : "#6b7280",
        borderBottom:
          tabIndex === index ? "3px solid #0f766e" : "3px solid transparent",
        background: "transparent",
        outline: "none",
        transition: "all 0.2s ease",
      }}
    >
      {label}
    </Tab>
  ))}
</TabList>
<TabPanel>
  <div
    style={{
      background: "#ffffff",
      padding: "0px",
    }}
  >
    <div
      style={{
        maxWidth: "1200px",
        margin: "auto",
        padding: "30px 24px",
       marginBottom: "10px",
        borderRadius: "14px",
        background:
          "linear-gradient(135deg, #ffffff 0%, #f8fafc 60%, #ecfdf5 100%)",
      }}
    >
      <div style={{ maxWidth: "820px", marginBottom: "26px" }}>
        <p
          style={{
            fontSize: "12px",
            fontWeight: 800,
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            color: "#0f766e",
            marginBottom: "8px",
          }}
        >
          Welcome to your dashboard
        </p>

        <h4
          style={{
            fontSize: "26px",
            fontWeight: 800,
            color: "#0f172a",
            marginBottom: "10px",
            lineHeight: "1.3",
          }}
        >
          Everything related to your account in one place.
        </h4>

        <p
          style={{
            fontSize: "14px",
            color: "#475569",
            lineHeight: "1.8",
            marginBottom: 0,
          }}
        >
          Use this dashboard to keep your profile updated, access your enrolled
          courses, review your appointments, view invoices, and manage account
          security whenever required.
        </p>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: "18px",
        }}
      >
        <div
          style={{
            background: "#ffffff",
            border: "1px solid #e5e7eb",
            borderRadius: "12px",
            padding: "20px",
            boxShadow: "0 10px 25px rgba(15, 23, 42, 0.04)",
          }}
        >
          <div
            style={{
              width: "42px",
              height: "42px",
              borderRadius: "50%",
              background: "#ecfdf5",
              color: "#0f766e",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 800,
              marginBottom: "14px",
            }}
          >
            1
          </div>

          <h6
            style={{
              fontSize: "15px",
              fontWeight: 800,
              color: "#111827",
              marginBottom: "8px",
            }}
          >
            Profile Details
          </h6>

          <p
            style={{
              fontSize: "13px",
              color: "#64748b",
              lineHeight: "1.7",
              marginBottom: "16px",
            }}
          >
            Update your name, contact number, email address, birth details and
            other personal information used for consultations.
          </p>

          <button
            type="button"
            onClick={() => setTabIndex(1)}
            style={{
              border: "none",
              background: "#0f766e",
              color: "#ffffff",
              borderRadius: "8px",
              padding: "10px 16px",
              fontSize: "12px",
              fontWeight: 800,
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              cursor: "pointer",
            }}
          >
            Manage Profile
          </button>
        </div>

        <div
          style={{
            background: "#ffffff",
            border: "1px solid #e5e7eb",
            borderRadius: "12px",
            padding: "20px",
            boxShadow: "0 10px 25px rgba(15, 23, 42, 0.04)",
          }}
        >
          <div
            style={{
              width: "42px",
              height: "42px",
              borderRadius: "50%",
              background: "#eff6ff",
              color: "#0a66c2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 800,
              marginBottom: "14px",
            }}
          >
            2
          </div>

          <h6
            style={{
              fontSize: "15px",
              fontWeight: 800,
              color: "#111827",
              marginBottom: "8px",
            }}
          >
            Your Courses
          </h6>

          <p
            style={{
              fontSize: "13px",
              color: "#64748b",
              lineHeight: "1.7",
              marginBottom: "16px",
            }}
          >
            Continue learning from purchased courses, check validity and open
            course invoices from one simple section.
          </p>

          <button
            type="button"
            onClick={() => setTabIndex(2)}
            style={{
              border: "2px solid #0a66c2",
              background: "#ffffff",
              color: "#0a66c2",
              borderRadius: "8px",
              padding: "8px 16px",
              fontSize: "12px",
              fontWeight: 800,
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              cursor: "pointer",
            }}
          >
            View Courses
          </button>
        </div>

        <div
          style={{
            background: "#ffffff",
            border: "1px solid #e5e7eb",
            borderRadius: "12px",
            padding: "20px",
            boxShadow: "0 10px 25px rgba(15, 23, 42, 0.04)",
          }}
        >
          <div
            style={{
              width: "42px",
              height: "42px",
              borderRadius: "50%",
              background: "#fff7ed",
              color: "#c2410c",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 800,
              marginBottom: "14px",
            }}
          >
            3
          </div>

          <h6
            style={{
              fontSize: "15px",
              fontWeight: 800,
              color: "#111827",
              marginBottom: "8px",
            }}
          >
            Your Appointments
          </h6>

          <p
            style={{
              fontSize: "13px",
              color: "#64748b",
              lineHeight: "1.7",
              marginBottom: "16px",
            }}
          >
            View your eConsultation bookings, session details, booking status
            and appointment invoices all at one place.
          </p>

          <button
            type="button"
            onClick={() => setTabIndex(3)}
            style={{
              border: "2px solid #c2410c",
              background: "#ffffff",
              color: "#c2410c",
              borderRadius: "8px",
              padding: "8px 16px",
              fontSize: "12px",
              fontWeight: 800,
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              cursor: "pointer",
            }}
          >
            View Appointments
          </button>
        </div>
      </div>

      <div
        style={{
          marginTop: "22px",
          padding: "16px 18px",
          borderRadius: "12px",
          background: "#f8fafc",
          border: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <div>
          <h6
            style={{
              fontSize: "14px",
              fontWeight: 800,
              color: "#111827",
              marginBottom: "4px",
            }}
          >
            Your are Signed in securely.
          </h6>

          <p
            style={{
              fontSize: "13px",
              color: "#64748b",
              marginBottom: 0,
            }}
          >
            Your Customer ID is: {" "}
            <b style={{ color: "#0f766e" }}>#{userId || "Loading..."}</b>
          </p>
        </div>

        <NavLink
          to={`/userpassword/${userId}`}
          style={{
            padding: "10px 16px",
            borderRadius: "8px",
            border: "2px solid #111827",
            background: "#111827",
            color: "#ffffff",
            fontSize: "12px",
            fontWeight: 800,
            textDecoration: "none",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
          }}
        >
          Change Password
        </NavLink>
      </div>
    </div>
  </div>
</TabPanel>
    <TabPanel>
      <div
    style={{
      background: "#ffffff",
      padding: "0px",
    }}
  >
<div className="row" style={{maxWidth:"1200px", margin:"auto", padding:"auto"}}>
            <div className="col-lg-12" style={{}}>
              <div className="form-candidate form-checkout form-stc">
                <div className="group-title" style={{ marginTop: 28, marginBottom: 16 }}>
  <h6
    style={{
      textAlign: "left",
      fontSize: "14px",
      fontWeight: 700,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      color: "#0f172a",
      marginBottom: 8,
    }}
  >
    Manage Your Account [<span style={{color:"green"}}><b>User Id</b>: {userId && <span>#{userId}</span>}</span>]
  </h6>

  <p
    style={{
      textAlign: "left",
      fontSize: "13px",
      lineHeight: "1.7",
      color: "#475569",
      maxWidth: "850px",
      margin: 0,
    }}
  >
    <span style={{ fontWeight: 600, color: "#111827" }}>
      Why is this important?
    </span>{" "}
    Keeping your profile updated helps us deliver accurate, personalised
    consultations and ensures a smooth experience across all services.
  </p>
</div>
               
                <form onSubmit={handleSubmit} style={{textAlign:"left"}}>
                  <div className="group-input" style={{marginBottom:"0px"}}>
                    <div className="ip" style={{marginBottom:"15px"}}>
                      <label style={{float:"left", fontWeight:"bold", fontSize:"13px"}}>Full Name</label>
                      <input type="text" name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      placeholder="Full Name"  style={{backgroundColor:"#fafafa", color:"black"}} />
                       {errors.fullName && <p className="error">{errors.fullName}</p>}
                    </div>
                    <div className="ip" style={{marginBottom:"15px"}}>
                      <label  style={{float:"left", fontWeight:"bold", fontSize:"13px"}}>Gender</label>
                      <select
  name="gender"
  value={formData.gender}
  onChange={handleChange}
  onBlur={handleBlur} // Trigger validation when the field loses focus
  className={errors.gender ? "input-error" : ""} // Apply error styling
 style={{backgroundColor:"#fafafa", color:"black"}}
>
  <option value="">Select Gender</option>
  <option value="male">Male</option>
  <option value="female">Female</option>
  <option value="other">Prefer Not To Say</option>
</select>

{errors.gender && <span className="error-message">{errors.gender}</span>}
                    </div>
                    <div className="ip" style={{marginBottom:"15px"}}>
                      <label style={{float:"left", fontWeight:"bold", fontSize:"13px"}}>IN Contact No.</label>
                      <input type="text" name="contactNo"
  value={formData.contactNo}
  onChange={handleChange}
  inputMode="numeric"
  pattern="\d*"
  maxLength="10"
  placeholder="Contact No."  style={{backgroundColor:"#fafafa", color:"black"}} />
  {errors.contactNo && <p className="error">{errors.contactNo}</p>}
                    </div>
                    <div className="ip" style={{marginBottom:"15px"}}>
                      <label  style={{float:"left", fontWeight:"bold", fontSize:"13px"}}>Email Address</label>
                      <input type="text" name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Email Address"  style={{backgroundColor:"#fafafa", color:"black"}} />
                      {errors.email && <p className="error">{errors.email}</p>}
                    </div>

                    <div className="ip" style={{marginBottom:"15px"}}>
                      <label  style={{float:"left", fontWeight:"bold", fontSize:"13px"}}>Date Of Birth</label>
                      <input type="date" name="Dateofbirth"
                      value={formData.Dateofbirth}
                      onChange={handleChange}
                      placeholder="Date Of Birth"  style={{backgroundColor:"#fafafa", color:"black"}} />
                      {errors.Dateofbirth && <p className="error">{errors.Dateofbirth}</p>}
                    </div>

                     <div className="ip" style={{marginBottom:"15px"}}>
                      <p  style={{float:"left", fontWeight:"bold", fontSize: "13px", marginBottom: "12px", position: "relative"}}>Time Of Birth [Optional]</p>
                      <input type="time" name="Timeofbirth"
                      value={formData.Timeofbirth}
                      onChange={handleChange}
                      placeholder="Time Of Birth"  style={{backgroundColor:"#fafafa", color:"black"}} />
                      {/* {errors.Timeofbirth && <p className="error">{errors.Timeofbirth}</p>} */}
                    </div>

                     <div className="ip" style={{marginBottom:"15px"}}>
                      <p  style={{float:"left", fontWeight:"bold", fontSize: "13px", marginBottom: "12px", position: "relative"}}>Place Of Birth [Optional]</p>
                      <input type="text" name="Placeofbirth"
                      value={formData.Placeofbirth}
                      onChange={handleChange}
                      placeholder="Place Of Birth"  style={{backgroundColor:"#fafafa", color:"black"}} />
                      {/* {errors.Placeofbirth && <p className="error">{errors.Placeofbirth}</p>} */}
                    </div>





                 
                  </div>
                   <div className="group-input-st1">
                  <button
  type="submit"
  disabled={!hasChanges || isSubmitting}
  style={{
    cursor: !hasChanges || isSubmitting ? "not-allowed" : "pointer",
    opacity: !hasChanges || isSubmitting ? 0.6 : 1
  }}
>
  {isSubmitting ? "Please Wait..." : "Update Details"}
</button>
                  </div> 
                </form>
             <style>
            {`
              .Toastify__close-button {
                display: none;
              }
            
              .Toastify__toast {
                position: relative;
                padding-right: 30px;
              }
            `}
            </style>
                       <ToastContainer position="bottom-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover />
              </div>
            </div>
          </div> 
  </div>
    </TabPanel>

<TabPanel>
  <div
    style={{
      background: "#ffffff",
  padding: "0px",
    }}
  ><div className="table-container" style={{ maxWidth: "1200px", margin: "auto" }}>
  <table className="fake-table">
    <thead>
      <tr>
      <th style={{ ...thStyle, width: "60%" }}>Your Courses</th>
<th style={{ ...thStyle, width: "40%" }}>Access & Invoice</th>
      </tr>
    </thead>

    <tbody>
      {courseLedger.length === 0 ? (
        <tr>
          <td colSpan="2" style={{ textAlign: "center", color: "#777" }}>
            Loading Your Courses...
          </td>
        </tr>
      ) : (
        courseLedger.map((c, idx) => {
          const daysLeft = remainingDays(c.purchase_date, c.Validity);
          const expired = daysLeft <= 0;

          return (
            <tr key={idx}>
              {/* LEFT – Course Info */}
              <td style={{ fontSize: "13px", lineHeight: "22px" }}>
                <div style={{ display: "flex", gap: 14 }}>
                  <div>
                    <b style={{ fontSize: 15 }}>#{c.order_id} - {c.course_title}</b>
                    <div style={{ color: "#666" }}>
                      {c.educator} • {c.language}
                    </div>

                    <div style={{ marginTop: 6 }}>
                      <b>Purchased:</b> {c.purchase_date}
                    </div>

                    <div style={{ marginTop: 6 }}>
                      <span
                        style={{
                          fontWeight: 700,
                          color: expired ? "red" : "green"
                        }}
                      >
                        {expired
                          ? "Expired"
                          : `${daysLeft} days remaining`}
                      </span>
                    </div>
                  </div>
                </div>
              </td>

              {/* RIGHT – Actions */}
              <td style={{ fontSize: "13px", lineHeight: "22px", verticalAlign: "top" }}>
                <b>Amount Paid:</b> ₹{Number(c.Netamount).toFixed(2)}
                <br />
                <b>Invoice Date:</b> {c.invoice_date}

                <div style={{ marginTop: 12, display: "flex", gap: 14 }}>
                  {!expired && (
                    <Link
                      to={`/course-screen/${c.Courseid}`}
                      style={{
                        color: "#14a077",
                        fontWeight: 600,
                        textDecoration: "none"
                      }}
                    >
                      Start Learning →
                    </Link>
                  )}

                  <Link
                    to={`/invoice/${c.purchase_id}`}
                    style={{
                      color: "#0a66c2",
                      fontWeight: 600,
                      textDecoration: "none"
                    }}
                  >
                    View Invoice →
                  </Link>
                </div>
              </td>
            </tr>
          );
        })
      )}
    </tbody>
  </table>
</div></div>
 </TabPanel>  

<TabPanel>
  <div
    style={{
      background: "#ffffff",
      padding: "0px",
    }}
  >
    <div
      className="table-container"
      style={{
        maxWidth: "1200px",
        margin: "auto",
      }}
    >
      <table className="fake-table">
        <thead>
          <tr>
            <th style={{ ...thStyle, width: "55%" }}>
              Your Appointments
            </th>

            <th style={{ ...thStyle, width: "45%" }}>
              Session Details
            </th>
          </tr>
        </thead>

        <tbody>
          {loadingAppointments ? (
            <tr>
              <td
                colSpan="2"
                style={{
                  textAlign: "center",
                  padding: "30px",
                }}
              >
                Loading your appointments...
              </td>
            </tr>
          ) : appointments.length === 0 ? (
            <tr>
              <td
                colSpan="2"
                style={{
                  textAlign: "center",
                  color: "#777",
                  padding: "30px",
                }}
              >
                You have no appointments yet.
              </td>
            </tr>
          ) : (
            appointments.map((a, index) => {
              const rating = Number(a.ReviewRating || 0);

              return (
                <tr key={index}>

                  {/* ============================= */}
                  {/* LEFT - APPOINTMENT + PAYMENT */}
                  {/* ============================= */}

                  <td
                    style={{
                      fontSize: "13px",
                      lineHeight: "22px",
                      verticalAlign: "top",
                    }}
                  >
                    <b style={{ fontSize: "15px" }}>
                      #{a.BookingId} –{" "}
                      {a.Category || "Consultation"}
                    </b>

                    <br />

                    <b>Astrologer:</b>{" "}
                    {a.AstrologerName || "-"}

                    <br />

                    <div style={{ marginTop: "8px" }}>
                      <b>Price:</b>{" "}
                      ₹
                      {a.TotalPrice
                        ? Number(a.TotalPrice).toFixed(2)
                        : "0.00"} - <b>Discount:</b>{" "}
                      <span style={{ color: "#16a34a" }}>
                        ₹
                        {a.DiscountAmount
                          ? Number(a.DiscountAmount).toFixed(2)
                          : "0.00"}
                      </span> - <b>Amount Paid:</b>{" "}
                      <span
                        style={{
                          fontWeight: 700,
                          color: "#0f766e",
                        }}
                      >
                        ₹
                        {a.PaidAmount
                          ? Number(a.PaidAmount).toFixed(2)
                          : "0.00"}
                      </span>
                    </div>

                   

                    {/* ============================= */}
                    {/* REVIEW SECTION */}
                    {/* ============================= */}

                    <div
                      style={{
                        marginTop: "0px",
                        paddingTop: "12px",
                      }}
                    >

                      {rating > 0 ? (
                        <div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "2px",
                            }}
                          >
                            {[1, 2, 3, 4, 5].map((star) => (
                              <span
                                key={star}
                                style={{
                                  fontSize: "20px",
                                  color:
                                    star <= rating
                                      ? "#f59e0b"
                                      : "#d1d5db",
                                  lineHeight: "20px",
                                }}
                              >
                                ★
                              </span>
                            ))}
                          </div>

                          <div
                            style={{
                              marginTop: "4px",
                              fontSize: "12px",
                              color: "#6b7280",
                            }}
                          >
                            {rating}/5
                          </div>
                        </div>
                      ) : (
                        <Link
                          to={`/userappointments/${a.BookingId}`}
                          style={{
                            display: "inline-block",
                            padding: "8px 12px",
                            background: "#f8fafc",
                            border: "1px solid #e5e7eb",
                            borderRadius: "6px",
                            color: "#0f766e",
                            fontSize: "12px",
                            fontWeight: 700,
                            textDecoration: "none",
                          }}
                        >
                          <span
                            style={{
                              color: "#9ca3af",
                              marginRight: "6px",
                              fontSize: "16px",
                            }}
                          >
                            ☆☆☆☆☆
                          </span>

                          Please rate your experience →
                        </Link>
                      )}
                    </div>
                  </td>


                  {/* ============================= */}
                  {/* RIGHT - SESSION DETAILS */}
                  {/* ============================= */}

                  <td
                    style={{
                      fontSize: "13px",
                      lineHeight: "22px",
                      verticalAlign: "top",
                    }}
                  >
                    <div>
                      <b>Session Starts:</b>{" "}
                      {formatDate(a.start_datetime)}
                      {" • "}
                      {formatTime(a.start_datetime)} 
                      {" "}IST
                    </div>

                    <div style={{ marginTop: "5px" }}>
                      <b>Status:</b>{" "}
                      <span
                        style={{
                          fontWeight: "bold",
                          color:
                            String(a.Status).toLowerCase() ===
                            "completed"
                              ? "green"
                              : String(a.Status).toLowerCase() ===
                                "pending"
                              ? "orange"
                              : "red",
                        }}
                      >
                        {a.Status}
                      </span>
                    </div>

                    {/* ACTIONS */}

                    <div
                      style={{
                        marginTop: "14px",
                        display: "flex",
                        gap: "14px",
                        flexWrap: "wrap",
                      }}
                    >
                      {/* View Booking */}

                      <Link
                        to={`/userappointments/${a.BookingId}`}
                        style={{
                          color: "#14a077",
                          fontWeight: "600",
                          fontSize: "13px",
                          textDecoration: "none",
                        }}
                      >
                        View Booking →
                      </Link>

                      {/* View Invoice */}

                      <Link
                        to={`/appointmentinvoice/${a.BookingId}`}
                        style={{
                          color: "#0a66c2",
                          fontWeight: "600",
                          fontSize: "13px",
                          textDecoration: "none",
                        }}
                      >
                        View Invoice →
                      </Link>
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  </div>
</TabPanel>



 </Tabs>

      </div>
    </section>
        <section className="checkout-section" style={{paddingTop:"0px", paddingBottom:"0px"}}>
        <div className="tf-container">
       
           {/* Hide the following div if case 2 */}
<div >
{userStatus.Vstatus === "" && (
  <div style={{}}>
    <div
      className="row"
      style={{
        maxWidth: "1200px",
        margin: "auto",
        textAlign: "center",
        paddingTop: "20px",
        borderRadius: "5px",
        marginBottom: "25px",
        backgroundColor: "#FBEFF2",
      }}
    >
      <div className="col-lg-12">
        <div className="form-candidate form-checkout form-stc">
          <div className="group-title">
            <p style={{ textAlign: "left" }}>
              <b style={{ fontSize: "15px" }}>Your Account needs attention!</b>
              <br />
              Thank you for creating an account with us. Please verify your email address in order to get the most out of our specialised services.
              <br />
              <button
                onClick={handleVerifyClick}
                style={{
                  background: "none",
                  border: "none",
                  color: "green",
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontWeight: "bold",
                  padding: 0,
                  marginTop: "5px", fontSize:"14px"
                }}
              >
                Click here to verify your Email Address Now
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
)}

{/* Modal without any library */}
{showModal && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
    }}
  >
    <div
      style={{
        background: "#fff",
        padding: "20px",
        borderRadius: "8px",
        width: "90%",
        maxWidth: "400px",
        textAlign: "center",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
      }}
    >
      <h3 style={{ marginBottom: "15px", fontSize: "18px" }}>Email Address Not Found!</h3>
      <p style={{ fontSize: "14px" }}>
        Please use <b>Manage Your Account</b> to link an email address to your account.
      </p>
      <button
        onClick={() => setShowModal(false)}
        style={{
          marginTop: "15px",
          backgroundColor: "green",
          color: "#fff",
          border: "none",
          padding: "8px 16px",
          borderRadius: "4px",
          cursor: "pointer", fontWeight:"bold"
        }}
      >
        Close
      </button>
    </div>
  </div>
)}
  

</div>
          {/* Hide the above div if case 2 */}

          

         <div
  style={{
    maxWidth: "1200px",
    margin: "30px auto",
    padding: "20px 24px",
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "20px",
    flexWrap: "wrap",
  }}
>
  {/* LEFT – Info */}
  <div style={{ maxWidth: "700px" }}>
    <h6
      style={{
        fontSize: "14px",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        color: "#111827",
        marginBottom: "6px",
      }}
    >
      Account Security
    </h6>

    <p
      style={{
        fontSize: "13px",
        color: "#4b5563",
        marginBottom: 0,
        lineHeight: "1.6",
      }}
    >
      For your safety, we recommend logging out from shared or unknown devices
      and keeping your password updated regularly.
    </p>
  </div>

  {/* RIGHT – Actions */}
  <div
    style={{
      display: "flex",
      gap: "12px",
      alignItems: "center",
      flexWrap: "wrap",
    }}
  >
    

    {/* Logout */}
    <button
      onClick={logout}
      style={{
        padding: "10px 18px",
        borderRadius: "6px",
        border: "2px solid #111827",
        background: "#111827",
        color: "#ffffff",
        fontSize: "12px",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        cursor: "pointer",
        transition: "all 0.2s ease",
      }}
    >
      Logout
    </button>
  </div>
</div>
        </div>
      </section>
        
     
      
        <div
                  className="floating-buttons"
                  style={{
                    position: "fixed",
                    bottom: "20px",
                    left: "20px",
                    zIndex: "1000",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {/* Call Button */}
                  <a
                    href={`tel:+918960708425`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#007BFF",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      color: "white",
                      fontSize: "28px",
                    }}
                  >
                    <FaPhoneAlt />
                  </a>
                
                  {/* WhatsApp Button */}
                  <a
                    href={`https://wa.me/918960708425`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#25D366",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      color: "white",
                      fontSize: "28px",
                    }}
                  >
                    <FaWhatsapp />
                  </a>
                </div>
      <Footer2 />
      <Gotop />
    </>
  );
}

export default DashboardUser;
